import { createFiltersContext } from '@/hooks/filters/createFiltersContext'
import { useContainerFilters } from './useContainerFilters'

/**
 * Context y Provider para los filtros de contenedores
 * Usa el factory genérico createFiltersContext
 */
const { FiltersProvider, useFiltersContext } =
  createFiltersContext(useContainerFilters)

// Exportar con nombres específicos del módulo
export const ContainerFiltersProvider = FiltersProvider
export const useContainerFiltersContext = useFiltersContext
